import { Component } from 'react';
import Select from 'react-select';
import { Form, Input, InputGroup, Label } from 'reactstrap';

import ModalAddressBook from '../../Modals/ModalAddressBook';

import { isNumeric } from '../../../helpers/regex';
import { parsePhone } from '../../../utils';

// const phoneNumbRegex = /^(0)|(62)|(\+62)/;
class FormShipping extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: null,
      _openModalAddress: false,
      _error: null,
      _addingShipping: false
    }

    this.toggleModalAddress = this.toggleModalAddress.bind(this);
    this._handleClearAddress = this._handleClearAddress.bind(this);
    this._handleNextTab = this._handleNextTab.bind(this);
    this._handleSelectedAddress = this._handleSelectedAddress.bind(this);
    // this._handleDisableAlias = this._handleDisableAlias.bind(this);
    this._handlePhoneNumberRegex = this._handlePhoneNumberRegex.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.needValidateShipping && prevProps.needValidateShipping !== this.props.needValidateShipping) {
      const errors = this._getErrorsForm();
      // console.log("WOI GILA MASOK: ", errors, Object.keys(errors).length===0);
      this.props.toggleShippingFulFilled(Object.keys(errors).length === 0)
    }
  }

  toggleModalAddress() {
    this.setState({
      _openModalAddress: !this.state._openModalAddress
    })
  }

  _handleModalAddress() {
    return (
      <ModalAddressBook
        titleModal="ADDRESS BOOK"
        isOpen={this.state._openModalAddress}
        onToggle={this.toggleModalAddress}
        dataAddress={this.props.dataPostalCode && this.props.dataPostalCode.shippingHistory}
        countries={this.props.dataPostalCode && this.props.dataPostalCode.countries}
        provinces={this.props.dataPostalCode && this.props.dataPostalCode.provinces}
        cities={this.props.dataPostalCode && this.props.dataPostalCode.cities}
        handleClickAddress={this._handleClearAddress}
        selectedAddress={this._handleSelectedAddress}
      />
    )
  }

  _handleClearAddress() {
    this.setState({
      _openModalAddress: !this.state._openModalAddress,
      _error: '',
      _addingShipping: true
    })
    this.props.onChooseShipping("NEW_SHIPPING")
  }

  _handleSelectedAddress(item) {
    this.setState({
      _openModalAddress: !this.state._openModalAddress,
      _error: '',
      _addingShipping: false
    })
    this.props.onChooseShipping(item);
  }

  //HERE
  _handleNextTab(e) {
    e.preventDefault();
    const valid = this._validateForm();

    if (Object.keys(valid).length === 0) {
      this.props.handleNextTab()
    }
  }

  _handleDisableAlias() {
    const { shippingHistory = {} } = this.props.dataPostalCode || {};

    if (this.state._addingShipping == true || shippingHistory.data && shippingHistory.data.length === 0) {
      return false
    } else {
      return true
    }
  }

  _handlePhoneNumberRegex() {
    const { _phoneNumber } = this.props;

    this.props._updateState('_phoneNumber', parsePhone(_phoneNumber))
  }

  phoneKeyPress = (e) => {
    let event = e || window.event;
    // Handle key only accept number
    let key = event.keyCode || event.which
    key = String.fromCharCode(key)
    const regex = /[0-9]|\./
    if(!regex.test(key)){
      event.returnValue = false
      if(event.preventDefault) event.preventDefault()
    }
  }

  _getErrorsForm() {
    let errors = {};

    if (this.props._alias === '' || this.props._alias == undefined || this.props._alias == null)
      errors['_alias'] = ['Please insert alias.'];
    if (this.props._fullName === '' || this.props._fullName == undefined || this.props._fullName == null)
      errors['_fullName'] = ['Please insert recipient name.'];
    if (this.props._phoneNumber === '' || this.props._phoneNumber == undefined || this.props._phoneNumber == null)
      errors['_phoneNumber'] = ['Please insert phone number.'];
    else if (!isNumeric(this.props._phoneNumber))
      errors['_phoneNumber'] = ['Phone number must be numeric'];
    if (this.props._alamat === '' || this.props._alamat == undefined || this.props._alamat == null)
      errors['_alamat'] = ['Please insert address.'];
    if (this.props._province === '' || this.props._province == -1)
      errors['_province'] = ['Please choose province.'];
    if (this.props._city === '' || this.props._city == undefined)
      errors['_city'] = ['Please choose city.'];
    if (this.props._postalCode === '' || this.props._postalCode == undefined || this.props._postalCode == null)
      errors['_postalCode'] = ['Please insert postal code.'];
    else if (!isNumeric(this.props._postalCode))
      errors['_postalCode'] = ['Postal code must be numeric.'];

    return errors;
  }

  _validateForm() {
    const { _error } = this.state;
    const errors = this._getErrorsForm();

    if (Object.keys(errors).length) {
      this.setState({
        _error: { errors: { ...errors }, status_code: 422, message: 'Harap isi semua column berbintang' }
      })
    }
    else
      this.setState({ _error: '' })

    return errors;
  }

  _hasError(name) {
    if (this.state._error !== null && this.state._error.status_code === 422) {
      return Object.keys(this.state._error.errors).filter(err => err === name).length > 0;
    }

    return false;
  }

  render() {
    const { dataAuth, _alias, _fullName, _phoneNumber, _alamat, _notes, _phone, _phoneSelected, _phoneList, _country, _countrySelected, _countryList, _province, _provinceSelected, _provinceList, _city, _citySelected, _cityList, _postalCode, _handleChange, _handleSelectCountryChange, _handleSelectProvinceChange, _handleSelectCityChange, _handleSelectPhoneChange } = this.props;

    return (
      <div style={{ display: 'flex', flexDirection: 'column' }} className="form-shipping">
        {this._handleModalAddress()}
        {/* <div className="email-wrapper">
          <span>{dataAuth.email}</span>
        </div> */}
        <Form onSubmit={this._handleNextTab} style={{ padding: '0' }}>
          <Label>ALIAS (eg. ship to house or ship to office)</Label>
          <Input
            testID="co-shipping-recipient-alias"
            name="_alias"
            value={_alias}
            onChange={_handleChange}
            disabled={this._handleDisableAlias()}
          />
          <div className="error-wrapper">
            <span>{this.props._error !== null && this.props._error && this.props._error.status_code === 422 ? this.props._error.errors._alias : undefined}</span>
          </div>
          <Label>RECIPIENT NAME</Label>
          <Input
            name="_fullName"
            value={_fullName}
            onChange={_handleChange}
            testID="co-shipping-recipient-name"
          />
          <div className="error-wrapper">
            <span>{this.props._error && this.props._error !== null && this.props._error.status_code === 422 ? this.props._error.errors._fullName : undefined}</span>
          </div>
          <Label>MOBILE PHONE</Label>
          <div className="option-wrapper">
            <div style={{ display: 'flex', flexDirection: 'column', marginRight: "10px" }}>
              <Select
                // value={_country}
                testID="co-shipping-phone-prefix"
                value={_phoneSelected}
                onChange={_handleSelectPhoneChange}
                options={_phoneList}
                menuIsOpen={true}
                classNamePrefix="province-options"
                placeholder="AREA CODE"
              />
              <div className="error-wrapper">
                <span>{this.props._error && this.props._error !== null && this.props._error.status_code === 422 ? this.props._error.errors._phone : undefined}</span>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', width: "100%" }}>
              <InputGroup>
                <Input
                  testID="co-shipping-phone-number"
                  name="_phoneNumber"
                  value={_phoneNumber ? parsePhone(_phoneNumber) : _phoneNumber}
                  onBlur={this._handlePhoneNumberRegex}
                  onChange={_handleChange}
                  onKeyPress={this.phoneKeyPress}
                  type={navigator.userAgent.match(/ipad|ipod|iphone|Android|BlackBerry|Windows Phone/i)? "number" : ""}
                />
              </InputGroup>
              <div className="error-wrapper">
                <span>{this.props._error && this.props._error !== null && this.props._error.status_code === 422 ? this.props._error.errors._phoneNumber : undefined}</span>
              </div>
            </div>
          </div>
          <Label>ADDRESS</Label>
          <Input
            testID="co-shipping-alamat"
            name="_alamat"
            value={_alamat}
            onChange={_handleChange}
          />
          <div className="error-wrapper">
            <span>{this.props._error && this.props._error !== null && this.props._error.status_code === 422 ? this.props._error.errors._alamat : undefined}</span>
          </div>
          <Label>NOTE</Label>
          <Input
            testID="co-shipping-notes"
            name="_notes"
            value={_notes}
            onChange={_handleChange}
          />
          <div className="option-wrapper">
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <Select
                testID="co-shipping-country"
                value={_countrySelected}
                onChange={_handleSelectCountryChange}
                options={_countryList}
                menuIsOpen={true}
                classNamePrefix="province-options"
                placeholder="COUNTRY"
              />
              <div className="error-wrapper">
                <span>{this.props._error && this.props._error !== null && this.props._error.status_code === 422 ? this.props._error.errors._country : undefined}</span>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <Select
                testID="co-shipping-province"
                value={_provinceSelected}
                onChange={_handleSelectProvinceChange}
                options={_provinceList}
                menuIsOpen={true}
                classNamePrefix="province-options"
                placeholder="PROVINCE"
              />
              <div className="error-wrapper">
                <span>{this.props._error && this.props._error !== null && this.props._error.status_code === 422 ? this.props._error.errors._province : undefined}</span>
              </div>
            </div>
          </div>
          <div className="option-wrapper" style={{ marginTop: 0 }}>
            <div>
              <Select
                // value={_city}
                testID="co-shipping-city"
                value={_citySelected}
                onChange={_handleSelectCityChange}
                options={_cityList}
                placeholder="CITY"
              />
              <div className="error-wrapper">
                <span>{this.props._error && this.props._error !== null && this.props._error.status_code === 422 ? this.props._error.errors._city : undefined}</span>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <Input
                testID="co-shipping-postalcode"
                name="_postalCode"
                value={_postalCode}
                onChange={_handleChange}
                className="postal-code"
                style={{
                  borderColor: '#d9d9d9 #ccc #b3b3b3',
                  border: '1px solid #ccc',
                  height: '36px',
                  width: '100%',
                }}
                placeholder="ZIP CODE"
              />
              <div className="error-wrapper">
                <span>{this.props._error && this.props._error !== null && this.props._error.status_code === 422 ? this.props._error.errors._postalCode : undefined}</span>
              </div>
            </div>
          </div>
          <div className="add-address">
            <span onClick={this.toggleModalAddress}>Choose Other Address</span>
          </div>
          {/* <div className="button-shipping-wrapper">
            <Button className="btn-green" color="secondary">NEXT</Button>
          </div> */}
        </Form>
      </div>
    )
  }
}

export default FormShipping;